import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, E = ({ size: e = 16, useVw: l, useRem: c, color: n, withColor: o, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-VIPjiebi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-VIPåå¸"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? r(n, 0, "#262933") : "#262933",
        datafollowfill: o ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M21.97 4.581a.85.85 0 0 1 0 1.203l-.969.969h5.815a.85.85 0 1 1 0 1.7h-5.815l.97.97a.85.85 0 1 1-1.202 1.202l-2.42-2.42a.85.85 0 0 1 0-1.203l2.42-2.42a.85.85 0 0 1 1.202 0Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.922 6.806a.372.372 0 0 1 .226-.073h4.868a.9.9 0 0 0 0-1.8h-4.868c-.596 0-1.177.242-1.586.686a.9.9 0 0 0-.092.118L3.778 12.92a1.99 1.99 0 0 0 .09 2.688l.003.002 11.026 11.517c.59.65 1.614.65 2.205 0l11.026-11.516.002-.003a1.99 1.99 0 0 0 .138-2.63l-1.131-2.437a.9.9 0 1 0-1.633.757l1.182 2.547c.04.085.091.163.155.231a.2.2 0 0 1 .058.14.205.205 0 0 1-.063.141l-10.837 11.32L5.167 14.36l-.004-.004a.204.204 0 0 1-.064-.14.2.2 0 0 1 .06-.14.904.904 0 0 0 .09-.118l4.673-7.153Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M13.218 16.37a.9.9 0 0 0-1.318 1.225l3.44 3.701a.9.9 0 0 0 1.276.043l3.934-3.7a.9.9 0 1 0-1.233-1.312l-3.275 3.08-2.824-3.037Z"
        }
      )
    )
  )));
}, s = E;
export {
  s as default
};
